// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {

    $w("#goto2").onClick((event) => { //this is the button that takes you to the second state
        $w("#statebox8").changeState("second"); //this is the ID of your multi-state box
 });

    $w("#goto1").onClick((event) => {  //this is the button that takes you to the first state
        $w("#statebox8").changeState("first"); //this is the ID of your multi-state box
 });

});